import { Component, ContentChild, Input, TemplateRef } from '@angular/core';
import * as i0 from "@angular/core";
export class TabComponent {
}
TabComponent.ɵfac = function TabComponent_Factory(t) { return new (t || TabComponent)(); };
TabComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TabComponent, selectors: [["mhe-tab"]], contentQueries: function TabComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, TemplateRef, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.contentTemplate = _t.first);
    } }, inputs: { name: "name", disabled: "disabled", ariaLabel: "ariaLabel" }, decls: 0, vars: 0, template: function TabComponent_Template(rf, ctx) { }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabComponent, [{
        type: Component,
        args: [{ selector: 'mhe-tab', template: '' }]
    }], null, { name: [{
            type: Input
        }], disabled: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], contentTemplate: [{
            type: ContentChild,
            args: [TemplateRef, { static: true }]
        }] }); })();
